import React, { useState } from "react";

// region External Libraries
import { Checkbox } from "@mui/material";
// endregion External Libraries
// region Atoms
import UserIcon from "@atoms/UserIcon";
import UserDetails from "@atoms/UserDetails";
import UserModuleList from "src/atoms/UserModuleList";
// endregion Atoms
// region Molecules
// endregion Molecules
// region Organisms
// endregion Organisms
// region Store
import { UserType } from "src/store/graphql/helpers/types.graphql";
// endregion Store
import * as Styled from "./styles";

interface IUserSelectionCardProps {
  currentUser: UserType;
  initialValue: boolean;
  onChangeCheckbox: (checked: boolean) => void;
}

const UserSelectionCard: React.FC<IUserSelectionCardProps> = (
  { currentUser, initialValue, onChangeCheckbox }
) => {
  // region States
  const [checked, setChecked] = useState(initialValue);
  // endregion States

  // region Functions
  /**
   * Returns the names of the modules this user is allowed to enter. Prefers
   * the canonical source (UserModuleAccess via the userModuleAccesses field);
   * falls back to deriving from userRoles → role.module for backwards
   * compatibility while the frontend codegen catches up with the backend
   * change in production. See docs/MODULE_ACCESS.md.
   */
  const getModuleNamesOfUserRoles = () => {
    const fromAccesses = currentUser.userModuleAccesses
      ?.map((access) => access?.module?.name)
      .filter((name): name is string => Boolean(name));

    if (fromAccesses && fromAccesses.length > 0) return fromAccesses;

    return currentUser.userRoles?.map((userRole) => userRole?.role?.module?.name || "") || [];
  };
  // endregion Functions

  // region Handlers
  const handleChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();

    setChecked(event.target.checked);

    onChangeCheckbox(event.target.checked);
  };
  // endregion Handlers

  return (
    <Styled.Container>
      <Styled.Icon>
        <UserIcon userImg={currentUser.imageUrl || undefined} blockMoreInfo active={currentUser.active} />
      </Styled.Icon>
      <Styled.Description>
        <UserDetails
          name={currentUser.name}
          position={currentUser.position}
          email={currentUser.email}
        />
        <UserModuleList modules={getModuleNamesOfUserRoles()} />
      </Styled.Description>
      <Styled.Checkbox onClick={(e) => e.stopPropagation()}>
        <Checkbox
          checked={checked}
          size="small"
          onChange={handleChangeCheckbox}
          inputProps={{ "aria-label": "controlled" }}
        />
      </Styled.Checkbox>
    </Styled.Container>
  );
};

export default UserSelectionCard;